export default __webpack_public_path__ + "static/media/adjust2screen.1d411909.svg";